import { useState, useEffect, useRef } from "react";
import clienteAxios from "../../axios";
import Dasboard from "../dasboard/dashboard";
import ModalConfirm from '../ModalConfirm';
import { useNavigate } from "react-router-dom";
import Pagos from "./Pagos";
import ArticulosComanda from "./ArticulosComanda";


const Comandas = () => {    
    const [comandas, setComandas] = useState([]);
    const [nuevaComanda, setNuevaComanda] = useState({
        mesa_id: '', estado: "", monto_total: ""
    });
    const [editandoComandaId, setEditandoComandaId] = useState(null);
    const [comandaEditada, setComandaEditada] = useState({
        mesa_id: '', estado: "", monto_total: ""
    });
    const [comandaSeleccionada, setComandaSeleccionada] = useState(null);
    const [mensajeExito, setMensajeExito] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [comandaAEliminar, setComandaAEliminar] = useState(null);
    const [mostrarFormulario, setMostrarFormulario] = useState(false);
    const [componenteActivo, setComponenteActivo] = useState(null);
    const [busqueda, setBusqueda] = useState(""); // Nuevo estado para la barra de búsqueda
    const formularioRef = useRef(null);
    const inputRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        obtenerComandas();
    }, []);

 

    // Obtener lista de comandas
    const obtenerComandas = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "comandas"
            });
            setComandas(response.data.data[0]);
        } catch (error) {
            console.log(error);
        }
    };

    // Función para manejar el cambio en la barra de búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Filtrar las transacciones en función del término de búsqueda
    // Filtrar las transacciones en función del término de búsqueda
    const comandasFiltradas = comandas.filter((comanda) => {
        return (
            (comanda.idComanda ? comanda.idComanda.toString().toLowerCase().includes(busqueda) : false) ||
            (comanda.estado ? comanda.estado.toString().toLowerCase().includes(busqueda) : false) ||
            (comanda.monto_total ? comanda.monto_total.toString().toLowerCase().includes(busqueda) : false)
        );
    });



    // Función para agregar una nueva comanda
    const handleAgregarComanda = async (e) => {
        e.preventDefault();

        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "comandas",
                ...nuevaComanda
            });

            setNuevaComanda({
                mesa_id: 1, estado: "Abierta", monto_total: 0.00
            });
            setMensajeExito(true);
            setTimeout(() => setMensajeExito(false), 3000);
            obtenerComandas();
            setMostrarFormulario(false); // Esconde el formulario tras agregar la comanda
        } catch (error) {
            console.log(error);
        }
    };

    // Función para editar una comanda existente
    const editarComanda = (idComanda, comandaActual) => {
        setEditandoComandaId(idComanda);
        setComandaEditada(comandaActual);
        setComandaSeleccionada(idComanda);
        setTimeout(() => {
            if (inputRef.current && inputRef.current.type === 'text') {
                inputRef.current.focus();
                inputRef.current.setSelectionRange(0, 0);
            }
        }, 0);
    };

    // Función para guardar los cambios de la comanda editada
    const guardarComandaEditada = async (idComanda) => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "comandas",
                id: idComanda,
                ...comandaEditada
            });

            setEditandoComandaId(null);
            setComandaSeleccionada(null);
            obtenerComandas();
        } catch (error) {
            console.log(error);
        }
    };

    // Función para confirmar la eliminación de una comanda
    const confirmarEliminarComanda = (idComanda) => {
        setShowConfirmModal(true);
        setComandaAEliminar(idComanda);
    };

    const ejecutarEliminarComanda = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar", // Asegúrate de corregir este error de ortografía en tu API si es necesario
                modulo: "comandas",
                id: comandaAEliminar
            });

            setShowConfirmModal(false);
            obtenerComandas();
        } catch (error) {
            console.log(error);
        }
    };

    const cancelarSeleccion = () => {
        setComandaSeleccionada(null);
        setEditandoComandaId(null);
        setComponenteActivo(null);
    };

    const handleMostrarFormulario = () => {
        setMostrarFormulario(true);
        setTimeout(() => {
            formularioRef.current.scrollIntoView({ behavior: 'smooth' });
        }, 100); // Un pequeño retraso para asegurar que el formulario esté visible antes de hacer scroll
    };

    return (
        <>
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar esta comanda?"
                onConfirm={ejecutarEliminarComanda}
                onCancel={() => setShowConfirmModal(false)}
            />

            
                <>
                    <Dasboard  /> {/* Mostrar el dashboard */}

                    <main className="-mt-32">
                        <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
                            <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6 max-w-full overflow-hidden">
                                <h2 className="text-2xl font-bold mb-6 mt-4">Comandas</h2>

                                {/* Barra de búsqueda */}
                                <input
                                    type="text"
                                    placeholder="Buscar transacción..."
                                    value={busqueda}
                                    onChange={handleBusqueda}
                                    className="border rounded-lg p-2 mb-4 w-full"
                                />

                                <ul>
                                    {comandasFiltradas.map((comanda) => (
                                        <li key={comanda.id} className="border-4 p-4 rounded-lg mb-4 cursor-pointer"
                                            onClick={() => setComandaSeleccionada(comanda.id)}>

                                            <div className="relative">
                                                {comandaSeleccionada === comanda.id && (
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            cancelarSeleccion();
                                                        }}
                                                        className="absolute top-[-1rem] right-0 text-gray-500 hover:text-red-500 p-2 text-3xl"
                                                    >
                                                        &times;
                                                    </button>
                                                )}
                                                {editandoComandaId === comanda.id ? (

                                                    <div className="flex flex-col">
                                                        <h3 className=" font-semibold">Mesa ID:</h3>
                                                        <input
                                                            type="number"
                                                            ref={inputRef}
                                                            value={comandaEditada.mesa_id}
                                                            onChange={(e) => setComandaEditada({ ...comandaEditada, mesa_id: e.target.value })}
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={10}
                                                        />

                                                        <h3 className=" font-semibold">Estado:</h3>
                                                        <input
                                                            type="text"
                                                            value={comandaEditada.estado}
                                                            onChange={(e) => setComandaEditada({ ...comandaEditada, estado: e.target.value })}
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={20}
                                                        />

                                                        <h3 className=" font-semibold">Monto Total:</h3>
                                                        <input
                                                            type="number"
                                                            value={comandaEditada.monto_total}
                                                            onChange={(e) => setComandaEditada({ ...comandaEditada, monto_total: e.target.value })}
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={15}
                                                        />

                                                        <div className="flex mt-4">
                                                            <button onClick={() => guardarComandaEditada(comanda.id)}
                                                                className="bg-green-500 text-white rounded px-2 py-1 mr-2 w-40">Guardar</button>
                                                            <button onClick={() => setEditandoComandaId(null)}
                                                                className="bg-gray-500 text-white rounded px-2 py-1 w-40">Cancelar</button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="flex flex-col">
                                                        <span><strong>Mesa ID:</strong> {comanda.mesa_id}</span>
                                                        <span><strong>Estado:</strong> {comanda.estado}</span>
                                                        <span><strong>Monto Total:</strong> {comanda.monto_total}</span>
                                                    </div>
                                                )}
                                            </div>

                                            {comandaSeleccionada === comanda.id && !editandoComandaId && (
                                                <>
                                                    <div className="flex items-center ">
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                editarComanda(comanda.id, comanda);
                                                            }}
                                                            className="bg-gray-500 text-white rounded px-2 py-1 mr-2 hover:bg-gray-400"
                                                        >
                                                            Editar Comanda
                                                        </button>

                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                confirmarEliminarComanda(comanda.id);
                                                            }}
                                                            className="bg-red-600 text-white rounded px-2 py-1 mr-2 hover:bg-red-500"
                                                        >
                                                            Borrar Comanda
                                                        </button>
                                                    </div>
                                                    <div className="mt-12 space-y-2">
                                                        <>
                                                            {/* Botón para Mostrar Pagos */}
                                                            <button
                                                                onClick={() => setComponenteActivo('pagos')}
                                                                className={`px-4 py-2 rounded mr-2 ${componenteActivo === 'pagos' ? 'bg-green-500 text-white' : 'bg-gray-500 text-white'}`}
                                                            >
                                                                Pagos
                                                            </button>


                                                            {/* Botón para Mostrar Articulos de la comanda */}
                                                            <button
                                                                onClick={() => setComponenteActivo('articulos')}
                                                                className={`px-4 py-2 rounded ${componenteActivo === 'articulos' ? 'bg-green-500 text-white' : 'bg-gray-500 text-white'}`}
                                                            >
                                                                Articulos
                                                            </button>


                                                            {/* Mostrar el componente seleccionado */}
                                                            {componenteActivo === 'pagos' && <Pagos comandaId={comanda.id} />}


                                                            {componenteActivo === 'articulos' && <ArticulosComanda comandaId={comanda.id} />}

                                                        </>
                                                    </div>
                                                </>
                                            )}
                                        </li>
                                    ))}
                                </ul>

                                {/* Botón para mostrar el formulario */}
                                {!mostrarFormulario && (
                                    <div className="flex ">
                                        <button
                                            onClick={handleMostrarFormulario}
                                            className="bg-blue-500 text-white rounded px-4 py-2 mb-4 hover:bg-blue-400"
                                        >
                                            Agregar nueva comanda
                                        </button>
                                    </div>
                                )}

                                {/* Mostrar formulario si el estado "mostrarFormulario" es verdadero */}
                                {mostrarFormulario && (
                                    <form onSubmit={handleAgregarComanda} className="flex flex-col space-y-4 mt-4" ref={formularioRef}>
                                        <h3 className="text-lg font-semibold">Agregar nueva Comanda</h3>
                                        <input
                                            type="number"
                                            value={nuevaComanda.mesa_id}
                                            onChange={(e) => setNuevaComanda({ ...nuevaComanda, mesa_id: e.target.value })}
                                            placeholder="Mesa ID"
                                            className="border rounded-lg p-2"
                                            maxLength={10}
                                        />
                                        <input
                                            type="text"
                                            value={nuevaComanda.estado}
                                            onChange={(e) => setNuevaComanda({ ...nuevaComanda, estado: e.target.value })}
                                            placeholder="Estado"
                                            className="border rounded-lg p-2"
                                            maxLength={20}
                                        />
                                        <input
                                            type="number"
                                            value={nuevaComanda.monto_total}
                                            onChange={(e) => setNuevaComanda({ ...nuevaComanda, monto_total: e.target.value })}
                                            placeholder="Monto Total"
                                            className="border rounded-lg p-2"
                                            maxLength={15}
                                        />
                                        <div className="flex space-x-4">
                                            <button type="submit" className="bg-green-500 rounded text-white px-4 py-2">
                                                Agregar Comanda
                                            </button>
                                            {/* Botón de cancelar */}
                                            <button
                                                type="button"
                                                onClick={() => setMostrarFormulario(false)}
                                                className="bg-gray-500 text-white rounded px-4 py-2"
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    </form>
                                )}

                                {mensajeExito && (
                                    <p className="text-pink-500 mt-2">Comanda agregada exitosamente</p>
                                )}
                            </div>
                        </div>
                    </main>
                </>            
        </>
    );
};

export default Comandas;
